import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { DocumentModel } from "../Models/DocumentModel";
import { environment } from "environments/environment";
import { TempEServicesDocumentModel } from "../Models/TempEServicesDocumentModel";


@Injectable()
export class UploaderService {

  constructor(private http: HttpClient) { }

  AddDocument(file: File, content: any): Observable<DocumentModel> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    };
    return this.http.post<DocumentModel>(environment.uploader_add, {
      content: content,
      name: file.name.split('.')[0],
      extension: file.name.split('.')[file.name.split('.').length - 1],
      mimeType: file.type,
      size: file.size
    }, httpOptions);

  }

  Download(id: string): Observable<DocumentModel> {
    return this.http.get<DocumentModel>(environment.uploader_download + "?id=" + id);
  }
}
